import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { useForm } from "react-hook-form";
import provisional from "../../Assets/images/provisionalLandingImageAflac.jpg";
import divider from "../../Assets/images/lpDividerLine.png";
import { useTranslation } from "react-i18next";
import * as httpClient from "../../../util/httpClient";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";

const AflacRegister = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );

    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                              .split(";")
                              .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                              .split("=")[1]
                            ? document.cookie
                                  .split(";")
                                  .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                  .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    }, []);
    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            firstName: "",
            lastName: "",
            zipCode: "",
        },
    });
    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [state, setState] = useState({
        firstName: "",
        lastName: "",
        zipCode: "",
        showErrorMessage: false,
        showAccessCodeField: true,
        isLoading: false,
        errorMsg: "",
    });
    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.value === "checkbox" ? target.checked : target.value;
        const name = target.name;
        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

    const onSubmit = (data: any) => {
        setShowAccessCodeField(false);
        setState({ ...state, isLoading: true, showErrorMessage: true });
        const requestBody = {
            firstName: data.firstName,
            lastName: data.lastName,
            zip: data.zipCode,
            partnerID: partnerID,
        };
        httpClient
            .sendRequest("POST", `api/PssLandingPage/GetPssLandingPage8?enrollFileRequired=true`, requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding.length === 0) {
                    setShowAccessCodeField(true);
                } else if (data.provisionalResponseLanding.length != 0) {
                    props.history.push({
                        pathname:
                            "/Register?Type=" +
                            data.provisionalResponseLanding[0].contractStatus +
                            "&VALUE=" +
                            data.provisionalResponseLanding[0].provisionalID +
                            "&GNDNRLL=PSS",
                    });
                    window.location.reload();
                }
            })
            .catch(function (error) {
                reset();
                trigger();
                setState({
                    ...state,
                    showErrorMessage: true,
                    errorMsg: "Something went wrong. Please try again.",
                    isLoading: false,
                    firstName: "",
                    lastName: "",
                    zipCode: "",
                });
            });
    };
    return (
        <React.Fragment>
            {showAccessCodeField == true ? <PSSBannerMessage layout={"aflacpsslanding"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} /> : <div className="retailer_text"></div>}
            <main is="x3d" id="l-page-content main-content aflac8-pss-main">
                <div className="row l-page-container" style={{height:"24rem"}}>
                    <div
                        style={{
                            backgroundImage: `url(${provisional})`,
                        }}
                        id="aflac-main-left-bg"
                    ></div>
                    <div className="pss8-right" style={{bottom:"76px !important"}}>
                        <h1><strong>Register Your Aflac Fraud Protection</strong></h1>
                        <div className="receipt-code-copy">Please complete the fields below to continue registration.</div>
                        <form id="pss7-form-member-login" onSubmit={handleSubmit(onSubmit)}>
                            <div className="input-content pss2-input-content">
                                <div className="form-row">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="firstName">
                                            First Name
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            aria-required="true"
                                            className="pss8-access-code-input-pin access-code-input-pin"
                                            type="text"
                                            id="firstName"
                                            name="firstName"
                                            onChange={handleInputChange}
                                            ref={register({
                                                required: true,
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.firstName && errors.firstName.type === "required" && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">First Name is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="form-row ">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="lastName">
                                            Last Name
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            aria-required="true"
                                            className="pss8-access-code-input-pin access-code-input-pin"
                                            type="text"
                                            id="lastName"
                                            name="lastName"
                                            onChange={handleInputChange}
                                            ref={register({
                                                required: true,
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.lastName && errors.lastName.type === "required" && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">Last Name is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="form-row">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="zipCode">
                                            First 5 digits of Zip Code
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            aria-required="true"
                                            className="pss8-access-code-input-pin access-code-input-pin"
                                            type="text"
                                            id="zipCode"
                                            name="zipCode"
                                            onChange={handleInputChange}
                                            ref={register({
                                                required: true,
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.zipCode && errors.zipCode.type === "required" && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">First 5 digits of Zip Code is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="pss8-getstarted-rightcontent">
                                <button onClick={() => handleSubmit(onSubmit)} value="Next" className="mobile-button">Next</button>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
            <div className="divider-img">
                <img src={divider} alt="" />
            </div>
        </React.Fragment>
    );
};
export default AflacRegister;
